import { type IServiceProviderDate } from "@/interfaces/api/service-provider-date.interface"
import { BaseRepository } from "@/repositories/base-repository"

export class ServiceProviderDateRepository extends BaseRepository<IServiceProviderDate> {
  protected resourcePath = "administration/service-provider-dates"
}
